import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-dept-fields',
  standalone: false,
  templateUrl: './dept-fields.component.html',
  styleUrls: ['./dept-fields.component.scss'],
})
export class DeptFieldsComponent implements OnInit {

  @Input() pageSpecificFormObject;
  @Input() departmentList;
  @Input() canUpdate;

  // isIQACADMIN:boolean = false;
  // isWEBEQUI : boolean = false;
  // isOFFICE_CO : boolean = false;
  // loggedInUserName;
  // isFROMIQACDASHBOARD:boolean = false;
  constructor(
    // public userdataService : UserDataService
  ) { }

  ngOnInit() {
    console.log('canUpdate', this.canUpdate)
    // this.userdataService.getCurrentActiveSection().then(section =>{
    //   if(section){
    //     if(section === 'IQAC_DASHBORAD'){
    //       this.isFROMIQACDASHBOARD = true;
    //     }else {
    //       this.isFROMIQACDASHBOARD = false;
    //     }
    //   }
    // })
    // this.getUserInfo();
    // this.checkLoggedInUserRole();
  }

  // getUserInfo() {
  //   this.userdataService.getUserProfile().then(profile => {
  //     if (profile) {
  //       this.loggedInUserName = profile.emailId;
  //     }
  //   })
  // }

  // checkLoggedInUserRole() {
  //   this.userdataService.getLoggedInUserRole().then(roles => {
  //     if (roles) {
  //       if (roles.includes("IQAC_ADMIN")) {
  //         this.isIQACADMIN = true;
  //       }
  //       if (roles.includes("WEB_EQUI")) {
  //         this.isWEBEQUI = true;
  //       }
  //       if (roles.includes("OFFICE_EQUI")) {
  //         this.isOFFICE_CO = true;
  //       }
  //     }
  //   });
  // }

  // canUpdate(): boolean {
  //   if(this.pageSpecificFormObject.status != undefined){
  //     return (this.pageSpecificFormObject.id ) && !this.isFROMIQACDASHBOARD &&
  //     (this.pageSpecificFormObject.status == 'CREATED' 
  //     ||  (this.pageSpecificFormObject.status == 'REVERTED' && this.loggedInUserName == this.pageSpecificFormObject.createdBy)
  //     || (this.pageSpecificFormObject.status == 'RECALLED' && this.loggedInUserName == this.pageSpecificFormObject.createdBy)
  //     || (this.pageSpecificFormObject.status == 'RESENT' && this.loggedInUserName == this.pageSpecificFormObject.createdBy)
  //     || (this.pageSpecificFormObject.status == 'SHARED' && this.loggedInUserName != this.pageSpecificFormObject.createdBy))

  //   } else {
  //     return true
  //   }
  // }

}
